import type { CheckboxGroupProps } from '@chakra-ui/react'
import { CheckboxGroup } from '@chakra-ui/react'
import React from 'react'
import { withFormControl, type FormFieldProps } from './hoc/withFormControl'

// Component-specific props
export interface CheckboxGroupFormControlComponentProps extends Omit<CheckboxGroupProps, 'value' | 'onChange' | 'isDisabled' | 'name'> {
  valueAsNumber?: boolean
  valueAsBoolean?: boolean
}

// Base component that handles checkbox group logic
export const CheckboxGroupFormControlBase = React.forwardRef<
  HTMLDivElement,
  CheckboxGroupFormControlComponentProps & FormFieldProps<(string | number)[], HTMLDivElement>
>((props, _) => {
  const {
    // Form field props
    value,
    onChange,
    onBlur,
    isDisabled,
    name,
    // Component-specific props
    children,
    valueAsNumber,
    valueAsBoolean,
    ...checkboxGroupProps
  } = props

  const handleChange = (value: (string | number)[]) => {
    const transformedValue = value.map((val) => {
      if (valueAsNumber) {
        return parseInt(val.toString())
      }
      return val
    })
    onChange(transformedValue)
    onBlur()
  }

  return (
    <CheckboxGroup
      value={value ?? []}
      onChange={handleChange}
      isDisabled={isDisabled}
      {...checkboxGroupProps}
    >
      {children}
    </CheckboxGroup>
  )
})

  ; (CheckboxGroupFormControlBase as any).displayName = 'CheckboxGroupFormControlBase'

// Export the wrapped component
export const CheckboxGroupFormControl = withFormControl<CheckboxGroupFormControlComponentProps, (string | number)[], HTMLDivElement>(CheckboxGroupFormControlBase)